/* eslint-disable max-len */
/**
 * Awvent - OpenAIConnector API
 * Awvent OpenAIConnector Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import {
    HttpClient,
    HttpEvent,
    HttpHeaders,
    HttpParams,
    HttpResponse,
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

import { BooleanWebApiResponse } from '../../../common/models/booleanWebApiResponse';
import { AgentCreateCommand } from '../model/agentCreateCommand';
import { AgentDtoWebApiResponse } from '../model/agentDtoWebApiResponse';
import { AgentUpdateCommand } from '../model/agentUpdateCommand';

import { Configuration } from '../../../../configuration';
import { CustomHttpUrlEncodingCodec } from '../../../../encoder';
import { BASE_PATH } from '../../../../variables';
import { AgentAttachDocumentCommand } from '../model/agentAttachDocumentCommand';
import { AgentDtoIListWebApiPagedResponse } from '../model/agentDtoIListWebApiPagedResponse';

@Injectable()
export class AgentService {
    protected basePath = environment.api.openaiConnector;

    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string,
        @Optional() configuration: Configuration
    ) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public agentActivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<AgentDtoWebApiResponse>;
    public agentActivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<AgentDtoWebApiResponse>>;
    public agentActivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<AgentDtoWebApiResponse>>;
    public agentActivateIdPut(
        id: string,
        xTenantId: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error(
                'Required parameter id was null or undefined when calling agentActivateIdPut.'
            );
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling agentActivateIdPut.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<AgentDtoWebApiResponse>(
            'put',
            `${this.basePath}/Agent/Activate/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public agentAttachFilePut(
        xTenantId: string,
        body?: AgentAttachDocumentCommand,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<BooleanWebApiResponse>;
    public agentAttachFilePut(
        xTenantId: string,
        body?: AgentAttachDocumentCommand,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<BooleanWebApiResponse>>;
    public agentAttachFilePut(
        xTenantId: string,
        body?: AgentAttachDocumentCommand,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<BooleanWebApiResponse>>;
    public agentAttachFilePut(
        xTenantId: string,
        body?: AgentAttachDocumentCommand,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling agentAttachFilePut.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BooleanWebApiResponse>(
            'put',
            `${this.basePath}/Agent/AttachFile`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public agentDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<AgentDtoWebApiResponse>;
    public agentDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<AgentDtoWebApiResponse>>;
    public agentDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<AgentDtoWebApiResponse>>;
    public agentDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error(
                'Required parameter id was null or undefined when calling agentDeactivateIdPut.'
            );
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling agentDeactivateIdPut.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<AgentDtoWebApiResponse>(
            'put',
            `${this.basePath}/Agent/Deactivate/${encodeURIComponent(
                String(id)
            )}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param isActive
     * @param orderBy
     * @param isOrderByDescending
     * @param searchText
     * @param pageNumber
     * @param pageSize
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public agentGet(
        xTenantId: string,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<AgentDtoIListWebApiPagedResponse>;
    public agentGet(
        xTenantId: string,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<AgentDtoIListWebApiPagedResponse>>;
    public agentGet(
        xTenantId: string,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<AgentDtoIListWebApiPagedResponse>>;
    public agentGet(
        xTenantId: string,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling agentGet.'
            );
        }

        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (isActive !== undefined && isActive !== null) {
            queryParameters = queryParameters.set('IsActive', <any>isActive);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append(
                    'OrderBy',
                    <any>element
                );
            });
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set(
                'IsOrderByDescending',
                <any>isOrderByDescending
            );
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set(
                'SearchText',
                <any>searchText
            );
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set(
                'PageNumber',
                <any>pageNumber
            );
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<AgentDtoIListWebApiPagedResponse>(
            'get',
            `${this.basePath}/Agent`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public agentIdDelete(
        id: string,
        xTenantId: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<BooleanWebApiResponse>;
    public agentIdDelete(
        id: string,
        xTenantId: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<BooleanWebApiResponse>>;
    public agentIdDelete(
        id: string,
        xTenantId: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<BooleanWebApiResponse>>;
    public agentIdDelete(
        id: string,
        xTenantId: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error(
                'Required parameter id was null or undefined when calling agentIdDelete.'
            );
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling agentIdDelete.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<BooleanWebApiResponse>(
            'delete',
            `${this.basePath}/Agent/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public agentIdGet(
        id: string,
        xTenantId: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<AgentDtoWebApiResponse>;
    public agentIdGet(
        id: string,
        xTenantId: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<AgentDtoWebApiResponse>>;
    public agentIdGet(
        id: string,
        xTenantId: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<AgentDtoWebApiResponse>>;
    public agentIdGet(
        id: string,
        xTenantId: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error(
                'Required parameter id was null or undefined when calling agentIdGet.'
            );
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling agentIdGet.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<AgentDtoWebApiResponse>(
            'get',
            `${this.basePath}/Agent/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param xRequestId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public agentPost(
        xTenantId: string,
        body?: AgentCreateCommand,
        xRequestId?: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<AgentDtoWebApiResponse>;
    public agentPost(
        xTenantId: string,
        body?: AgentCreateCommand,
        xRequestId?: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<AgentDtoWebApiResponse>>;
    public agentPost(
        xTenantId: string,
        body?: AgentCreateCommand,
        xRequestId?: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<AgentDtoWebApiResponse>>;
    public agentPost(
        xTenantId: string,
        body?: AgentCreateCommand,
        xRequestId?: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling agentPost.'
            );
        }

        let headers = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            headers = headers.set('x-request-id', String(xRequestId));
        }
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AgentDtoWebApiResponse>(
            'post',
            `${this.basePath}/Agent`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public agentPut(
        xTenantId: string,
        body?: AgentUpdateCommand,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<AgentDtoWebApiResponse>;
    public agentPut(
        xTenantId: string,
        body?: AgentUpdateCommand,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<AgentDtoWebApiResponse>>;
    public agentPut(
        xTenantId: string,
        body?: AgentUpdateCommand,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<AgentDtoWebApiResponse>>;
    public agentPut(
        xTenantId: string,
        body?: AgentUpdateCommand,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling agentPut.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AgentDtoWebApiResponse>(
            'put',
            `${this.basePath}/Agent`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
}
